export default "__VITE_ASSET__C_j_2$lJ__"